import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ShowProgressModule } from '@nibras/common-components/show-progress';
import { NibrasLoaderComponent } from './nibras-loader.component';

@NgModule({
  imports: [CommonModule, MatProgressSpinnerModule, ShowProgressModule],
  declarations: [NibrasLoaderComponent],
  exports: [NibrasLoaderComponent, ShowProgressModule]
})
export class NibrasLoaderModule {}
